import { createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@icons/Path_filtermain.svg'


const _hoisted_1 = {
  class: "filter-menu-container",
  "data-component-name": "facet-menu"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "filter-menu-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "arrow-back-icon"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Distance & shipping", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "filter-label" }
const _hoisted_8 = {
  key: 1,
  class: "filter-menu-header-outer"
}
const _hoisted_9 = { class: "filter-menu-header" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "arrow-back-icon"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "All Filters", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "filter-label" }
const _hoisted_14 = {
  key: 0,
  class: "filter-chips-mobile"
}
const _hoisted_15 = {
  key: 1,
  class: "facet-action-links"
}
const _hoisted_16 = { class: "filter-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sc_image = _resolveComponent("sc-image")!
  const _component_sc_text = _resolveComponent("sc-text")!
  const _component_CloseIcon = _resolveComponent("CloseIcon")!
  const _component_sc_placeholder = _resolveComponent("sc-placeholder")!
  const _component_ChevronDownIconBlue = _resolveComponent("ChevronDownIconBlue")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(_Transition, { name: "slide" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        (_ctx.filterZipFlyout)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_ctx.filterSelected)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "filter-back align-center",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setFilterZipFlyout(false))),
                      onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.setFilterZipFlyout(false)), ["enter"])),
                      tabindex: "0"
                    }, _hoisted_6, 32))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_sc_image, {
                    media: _ctx.fields.icon
                  }, null, 8, ["media"]),
                  _createVNode(_component_sc_text, {
                    field: _ctx.fields.label,
                    class: "filter-text",
                    "data-testid": "filter-text"
                  }, null, 8, ["field"])
                ], 512), [
                  [_vShow, !_ctx.filterSelected]
                ]),
                _createElementVNode("span", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleFilterMenu())),
                  class: "close-button"
                }, [
                  _createVNode(_component_CloseIcon)
                ]),
                _createElementVNode("span", {
                  class: "desktop-reset-button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resetFacets())),
                  onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.resetFacets()), ["enter"])),
                  tabindex: "0"
                }, [
                  _createVNode(_component_sc_text, {
                    field: _ctx.fields.button,
                    "data-testid": "reset-button-text-desktop"
                  }, null, 8, ["field"])
                ], 32)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_ctx.filterSelected)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "filter-back align-center",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resetFilters())),
                      onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.resetFilters()), ["enter"])),
                      tabindex: "0",
                      "data-action": "return-to-all-filters"
                    }, _hoisted_12, 32))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_sc_image, {
                    media: _ctx.fields.icon
                  }, null, 8, ["media"]),
                  _createVNode(_component_sc_text, {
                    field: _ctx.fields.label,
                    class: "filter-text",
                    "data-testid": "filter-text"
                  }, null, 8, ["field"])
                ], 512), [
                  [_vShow, !_ctx.filterSelected]
                ]),
                _createElementVNode("span", {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggleFilterMenu())),
                  class: "close-button"
                }, [
                  _createVNode(_component_CloseIcon)
                ]),
                _createElementVNode("span", {
                  class: "desktop-reset-button",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.resetFacets())),
                  onKeyup: _cache[9] || (_cache[9] = _withKeys(($event: any) => (_ctx.resetFacets()), ["enter"])),
                  tabindex: "0",
                  "data-action": "reset-facets"
                }, [
                  _createVNode(_component_sc_text, {
                    field: _ctx.fields.button,
                    "data-testid": "reset-button-text-desktop"
                  }, null, 8, ["field"])
                ], 32)
              ]),
              (!_ctx.filterSelected)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_component_sc_placeholder, {
                      name: "filter-chip",
                      rendering: _ctx.rendering,
                      hasBorderBottom: false,
                      isInMobileFilterMenu: false,
                      isFilterMenuOpen: _ctx.isFilterMenuOpen
                    }, null, 8, ["rendering", "isFilterMenuOpen"])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.filterSelected)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("span", {
                      class: "mobile-reset-link",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.resetFacets()))
                    }, [
                      _createVNode(_component_sc_text, {
                        field: _ctx.fields.button,
                        "data-testid": "reset-button-text-mobile"
                      }, null, 8, ["field"])
                    ]),
                    (_ctx.facetChipsExpanded && _ctx.isMobile && _ctx.hiddenChips > 0)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "mobile-collapse-link",
                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.hideFilterChips && _ctx.hideFilterChips(...args)))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.$t('srp.common.showLess')) + " ", 1),
                          _createVNode(_component_ChevronDownIconBlue)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])),
        _createElementVNode("div", {
          class: _normalizeClass(["filter-list", { 'mt-0': _ctx.filterZipFlyout }]),
          "data-menu-type": "filter-list"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["border-top", {
            'border-top-0': _ctx.filterZipFlyout,
            'filter-selected': _ctx.filterSelected,
          }])
          }, [
            _createVNode(_component_sc_placeholder, {
              rendering: _ctx.rendering,
              name: "filter-category",
              "data-role": "container"
            }, null, 8, ["rendering"])
          ], 2)
        ], 2),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_Button, {
            text: `View ${_ctx.formattedVehicleAmount} results`,
            onClick: _ctx.toggleFilterMenu
          }, null, 8, ["text", "onClick"])
        ])
      ], 512), [
        [_vShow, _ctx.isFilterMenuOpen]
      ])
    ]),
    _: 1
  }))
}